import { gql } from '@apollo/client';

export const GET_TASK_STAGES = gql`
  query GetTaskStages {
    vm {
      taskStages {
        taskStageId
        name
        automateApproval
        order
      }
    }
  }
`;